import axios from "axios";
import {
  BASE_URL,
  DEFAULT_HEADERS,
  CORS_HEADERS,
  API_TIMEOUT,
} from "../constants/api";

// const BASE_URL =
//   import.meta.env.VITE_API_BASE_URL ||
//   "https://bpo24-backend-dev.callfornia.com/api/v1";

const baseApi = axios.create({
  baseURL: BASE_URL,
  headers: DEFAULT_HEADERS,
  timeout: API_TIMEOUT, // 10-second timeout
  withCredentials: true, // Enable sending cookies in cross-origin requests
});

baseApi.defaults.maxRedirects = 2;

baseApi.interceptors.request.use((config) => {
  const access_token = localStorage.getItem("access_token");
  if (access_token) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }
  // Add CORS headers to every request
  Object.entries(CORS_HEADERS).forEach(([key, value]) => {
    config.headers[key] = value;
  });
  return config;
});

baseApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error", error);
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      window.location.href = "/login";
    }
    if (error.response?.status === 403) {
      // Dispatch custom event for 403 errors
      const event = new CustomEvent("api-403-error", {
        detail: {
          message:
            error.response?.data?.detail ||
            "Access forbidden. You do not have permission to perform this action.",
          status: 403,
        },
      });
      window.dispatchEvent(event);
    }
    return Promise.reject(error);
  }
);

export { baseApi, BASE_URL };

export { authApi } from "./authApi";
export { contactsApi } from "./contactsApi";
export { businessApi } from "./businessApi";
